import React, { useState } from 'react';
import ControldocDataTable from "../../../controldoc/datatable";

const BulkNotificationFillControldocFormDocumentList = props => {
  const {
    dataTableConfiguration: {
      columns: dataTableColumns
    },
    configuration: {
      defaultRequestParams
    },
    actions: {
      indexFormDocumentsPath
    },
  } = props;

  const formName = "bulk_notification_fill";
  const [selectedControldocFormDocuments, setSelectedControldocFormDocuments] = useState([]);

  const drawSelectedControldocFormDocumentsInput = () => {
    return (
      <>
        {_.map(selectedControldocFormDocuments, function (document) {
          return (
            <div key={`controldoc_form_document-input-${document.id}`}>
              <input
                type="hidden"
                name={`${formName}[items_attributes][][controldoc_form_document_id]`}
                value={document.id}
              />
            </div>
          );
        })}
      </>
    );
  };

  const onSelectionChange = selectedRecords => {
    setSelectedControldocFormDocuments(selectedRecords)
  }

  const drawControldocFormDocumentList = () => {
    return (
      <ControldocDataTable
        columns={dataTableColumns}
        configuration={{
          showDistributionListFilter: false,
          showGridlines: true,
          fetchRecords: {
            endpoint: indexFormDocumentsPath,
            keyName: "documents",
            defaultRequestParams: defaultRequestParams
          },
          selectable: {
            enabled: true,
            mode: 'multiple',
            selection: selectedControldocFormDocuments,
            onSelectionChange: onSelectionChange
          }
        }}
      >
      </ControldocDataTable>
    )
  }

  return (
    <div className="row">
      <div className="col-12">
        {drawControldocFormDocumentList()}
        {drawSelectedControldocFormDocumentsInput()}
      </div>
    </div>
  )
}

export default BulkNotificationFillControldocFormDocumentList;
